import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { formatMoney } from '../utils';
import { selectPublishTermsService as setPublishTermsService } from '../../../../../../../../../../../actions/publishTerms';
import { EServiceId } from '../../../../../../../../../../../types/reducers/publishTerms';
import { IUseServiceHook } from './types';
import { selectServiceById } from '../../../../../../../../../../../reducers/v2/promotion/selectors';
import { IPromotionService } from '../../../../../../../../../../../reducers/v2';
import { useServicesAnalytics } from '../../../../../hooks/useServicesAnalytics';

export const useService = (serviceId: EServiceId): IUseServiceHook => {
  const dispatch = useDispatch();

  const { trackServiceChange } = useServicesAnalytics();

  const service: IPromotionService = useSelector(selectServiceById(serviceId));
  const price = service.price;

  const formattedPrice = formatMoney(price);
  const isSelected = service.selected;

  const onClick = useCallback(() => {
    if (!isSelected) {
      dispatch(setPublishTermsService(serviceId));
    }

    trackServiceChange();
  }, [dispatch, isSelected, serviceId, trackServiceChange]);

  return {
    onClick,
    isSelected,
    price,
    formattedPrice,
  };
};
